import exportFromJSON from 'export-from-json';
import React, { useEffect, useState } from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import {
  VscCloudDownload,
  VscListUnordered,
  VscNewFile,
  VscRefresh,
  VscSearch,
} from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../services/actions';
import Bouton from '../../UI/Bouton/Bouton';
import Popup from '../../UI/Popup/Popup';
import Tableau from '../../UI/tableau/Tableau';
import SensorType from '../SensorType/SensorType';
import S from '../Capteur.module.scss';
const TableauCapteur = ({ creer, selectioneLigne }) => {
  const dispatch = useDispatch();

  // Redux state
  const listeCapteurs = useSelector((state) => state.capteur.capteursListe);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );

  // Local state with multiple useState hooks
  const [listExport, setListExport] = useState([]);
  const [columns, setColumns] = useState([
    {
      dataField: 'sensor_id',
      text: [
        checkMot('capteur_id'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('sensor_id', checkMot('capteur_id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'project_id',
      text: [
        checkMot('projet_id'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('projet_id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'type_id',
      text: [
        checkMot('id_type'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('type_id', checkMot('id_type'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'sensor_name',
      text: [
        checkMot('nom'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('sensor_name', checkMot('nom'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'sensors_group',
      text: [
        checkMot('groupe_de_capteurs'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('sensors_group', checkMot('groupe_de_capteurs'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'remarks',
      text: [
        checkMot('remarques'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('remarks', checkMot('remarques'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'format_date',
      text: [
        checkMot('format_date'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('format_date', checkMot('format_date'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'path_ascii_file',
      text: [
        checkMot('chemin_du_fichier_ascii'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre(
              'path_ascii_file',
              checkMot('chemin_du_fichier_ascii')
            )
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'position',
      text: [
        checkMot('position'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('position', checkMot('position'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'import_filter_id',
      text: [
        checkMot('filtre_importation_id'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre(
              'import_filter_id',
              checkMot('filtre_importation_id')
            )
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'emailgroup_id',
      text: [
        checkMot('id_du_groupe_d_email'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('emailgroup_id', checkMot('id_du_groupe_d_email'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'active',
      text: [
        checkMot('activite_du_capteur'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('active', checkMot('activite_du_capteur'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'sensor_projection',
      text: [
        checkMot('repere_du_capteur'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('sensor_projection', checkMot('repere_du_capteur'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'coordinate_x',
      text: [
        checkMot('coordonnee_x'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('coordinate_x', checkMot('coordonnee_x'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'coordinate_y',
      text: [
        checkMot('coordonnee_y'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('coordinate_y', checkMot('coordonnee_y'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'coordinate_z',
      text: [
        checkMot('coordonnee_z'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('coordinate_z', checkMot('coordonnee_z'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
  ]);

  // Effect for initial data fetch
  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      dispatch(actions.reqRecupererListeCapteurs([parseInt(project_id_url)]));
    } else if (filtre_projects_list_id.length > 0) {
      dispatch(actions.reqRecupererListeCapteurs(filtre_projects_list_id));
    }
  }, [project_id_url, filtre_projects_list_id, dispatch]);

  const afficherFiltre = (dataField, placeholder) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (col.dataField === dataField) {
          return {
            ...col,
            filter: textFilter({ placeholder }),
          };
        }
        return col;
      })
    );
  };

  const handleSelect = (row, isSelect) => {
    if (isSelect) {
      selectioneLigne(row);
      setListExport((prev) => [...prev, row]);
    } else {
      setListExport((prev) =>
        prev.filter((item) => item.sensor_id !== row.sensor_id)
      );
    }
  };

  const handleSelectAll = (isSelect, rows) => {
    setListExport(isSelect ? [...rows] : []);
  };

  const exporterConfiguration = () => {
    const data = { sensors_list: listExport };
    const fileName = 'ArgosCapteurListExport';
    const exportType = 'json';
    exportFromJSON({ data, fileName, exportType });
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: handleSelect,
    onSelectAll: handleSelectAll,
  };

  // Calculate hidden rows
  const listeCleACache =
    listeCapteurs?.reduce((acc, capteur) => {
      if (interfaceAdmin) {
        if (filtre_projects_list_id.indexOf(parseInt(capteur.project_id)) < 0) {
          acc.push(capteur.sensor_id);
        }
      } else {
        if (parseInt(capteur.project_id) !== parseInt(project_id_url)) {
          acc.push(capteur.sensor_id);
        }
      }
      return acc;
    }, []) || [];

  return (
    <>
      <Tableau
        cleLigne={'sensor_id'}
        privilegeCreer={[
          privilege.creer_des_capteurs,
          privilege.recuperer_list_sensor_type,
        ]}
        creer={creer}
        iconeCreer={<VscNewFile size={15} />}
        lignesCache={listeCleACache}
        donnees={listeCapteurs}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_capteurs}
          str={checkMot('requete_en_cours')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            type={type_btn.outil}
            rond={true}
            cliquer={() =>
              dispatch(
                actions.reqRecupererListeCapteurs(filtre_projects_list_id)
              )
            }
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
        <AccesRestreins numPrivilege={privilege.modifier_des_capteurs}>
          <Bouton
            type={type_btn.outil}
            rond={true}
            hoverText={checkMot('exporter')}
            cliquer={exporterConfiguration}
          >
            <VscCloudDownload size={15} />
          </Bouton>
          <Popup
            hoverText={checkMot('sensor_type')}
            typeBoutonAffichage={type_btn.outil}
            ajoutOverlay={S.Overlay}
            icone={<VscListUnordered size={15} />}
          >
            <SensorType />
          </Popup>
        </AccesRestreins>
      </Tableau>
    </>
  );
};

export default TableauCapteur;
